import { tablaComparativa } from '@/mocks/derechos-data';

export default function ComparativeTable() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-600 mb-2">
              Resumen
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
              {tablaComparativa.titulo}
            </h2>
          </div>

          {/* Table */}
          <div className="bg-white border border-secondary-200/60 rounded-2xl overflow-hidden">
            {/* Table Header */}
            <div className="grid grid-cols-3 bg-foreground-950">
              {tablaComparativa.columnas.map((col, idx) => (
                <div
                  key={col}
                  className={`px-5 md:px-8 py-4 md:py-5 ${
                    idx === 0
                      ? 'text-left'
                      : 'text-center border-l border-white/10'
                  }`}
                >
                  <span className={`text-xs md:text-sm font-bold tracking-wide uppercase whitespace-nowrap ${
                    idx === 0 ? 'text-secondary-300' : 'text-white'
                  }`}>
                    {col}
                  </span>
                </div>
              ))}
            </div>

            {/* Table Body */}
            <div>
              {tablaComparativa.filas.map((fila, idx) => (
                <div
                  key={fila.concepto}
                  className={`grid grid-cols-3 ${
                    idx % 2 === 0 ? 'bg-background-50/50' : 'bg-white'
                  } ${idx < tablaComparativa.filas.length - 1 ? 'border-b border-secondary-100' : ''}`}
                >
                  {/* Concepto */}
                  <div className="px-5 md:px-8 py-4 md:py-5 flex items-center">
                    <div className="flex items-center gap-2 md:gap-3">
                      <div className="w-2 h-2 rounded-full bg-primary-500 flex-shrink-0" />
                      <span className="text-foreground-800 text-xs md:text-sm font-semibold">
                        {fila.concepto}
                      </span>
                    </div>
                  </div>

                  {/* Fonograma */}
                  <div className="px-5 md:px-8 py-4 md:py-5 flex items-center justify-center border-l border-secondary-100">
                    <span className={`text-xs md:text-sm leading-relaxed text-center ${
                      fila.fonograma === 'SONIEM' || fila.fonograma === 'UNIMPRO'
                        ? 'font-bold text-primary-600'
                        : 'text-foreground-600'
                    }`}>
                      {fila.fonograma}
                    </span>
                  </div>

                  {/* Audiovisual */}
                  <div className="px-5 md:px-8 py-4 md:py-5 flex items-center justify-center border-l border-secondary-100">
                    <span className={`text-xs md:text-sm leading-relaxed text-center ${
                      fila.audiovisual === 'SONIEM'
                        ? 'font-bold text-primary-600'
                        : 'text-foreground-600'
                    }`}>
                      {fila.audiovisual}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Footnote */}
          <p className="text-foreground-400 text-xs text-center mt-5">
            La gestión colectiva en el Perú es voluntaria. SONIEM representa únicamente a los artistas que le han conferido mandato de gestión.
          </p>
        </div>
      </div>
    </section>
  );
}